import React from 'react';

/**
 * HeaderBrand
 * 
 * Brand lockup component for the top header.
 * Displays logo + "CLC Admin" text with responsive truncation.
 * 
 * @param {boolean} showText - Whether to show text (default: true)
 */
export default function HeaderBrand({ showText = true }) {
  return (
    <div className="admin-header-brand">
      <img 
        src="/brand/clc/logos/clc-logo-blue-768x768-png-cea5c7b9.webp" 
        alt="CLC" 
        className="admin-header-brand-logo"
      />
      {showText && (
        <span className="admin-header-brand-text">
          <span className="admin-header-brand-text-full">CLC Admin</span>
          <span className="admin-header-brand-text-short">CLC</span>
        </span>
      )}
    </div>
  );
}
